// Inactivity and absolute-lifetime policy for professional/admin sessions.
// Pure so the decision path is unit-tested. Homeowners are never subject to it.

export const STAFF_IDLE_LIMIT_MS = 30 * 60 * 1000;
export const STAFF_ABSOLUTE_LIMIT_MS = 8 * 60 * 60 * 1000;
/** A return after this long in the background re-checks sign-in with the server. */
export const BACKGROUND_RECHECK_MS = 5 * 60 * 1000;

export const PROFESSIONAL_ROLES = [
  "admin",
  "consultant",
  "installer",
  "partner",
  "marketing_manager",
  "introducer",
  "introducer_manager",
  "sales_manager",
  "customer_service",
  "surveyor",
] as const;

export type StaffSessionVerdict = "active" | "idle_expired" | "absolute_expired";

export function isProfessionalRoute(allowedRoles: readonly string[]): boolean {
  return allowedRoles.some((r) => (PROFESSIONAL_ROLES as readonly string[]).includes(r));
}

export function evaluateStaffSession(args: {
  now: number;
  lastActivityAt: number | null;
  sessionStartedAt: number | null;
}): StaffSessionVerdict {
  const { now, lastActivityAt, sessionStartedAt } = args;
  if (sessionStartedAt !== null && Number.isFinite(sessionStartedAt) && now - sessionStartedAt >= STAFF_ABSOLUTE_LIMIT_MS) {
    return "absolute_expired";
  }
  if (lastActivityAt !== null && Number.isFinite(lastActivityAt) && now - lastActivityAt >= STAFF_IDLE_LIMIT_MS) {
    return "idle_expired";
  }
  return "active";
}

/** Start of the current sign-in, from the server-issued sign-in time. */
export function sessionStartFrom(lastSignInAt: string | null | undefined, fallback: number): number {
  const parsed = lastSignInAt ? Date.parse(lastSignInAt) : NaN;
  return Number.isFinite(parsed) ? parsed : fallback;
}
